import { Paper, PaperProps, useTheme } from '@mui/material';

export const CustomPaper = (props: PaperProps) => {
  const theme = useTheme();
  return <Paper sx={{ backgroundColor: theme.palette.background.default }} {...props} />;
};
